export const infosCardsMapper = {
    cards: [
        { title: "30+", description: "Projetos realizados, entregues e aprovados por todo o Brasil." },
        { title: "12+", description: "Experiência combinada dos sócios no mercado." },
        { title: "20+", description: "Entregas e melhorias aplicadas em ambientes reais." },
        { title: "2x", description: "Mais agilidade na tomada de decisão com dados." }
    ],
    observerConfig: {
        threshold: 0.3,
        rootMargin: '0px 0px -100px 0px'
    },
    animationDelays: [50, 150, 250, 350]
};
